<template>
  <div class="k-form-field form-group" :class="`${required ? 'form-required' : ''}`">
    <label v-if="label" :for="fieldId">
      {{ label }}<k-tooltip v-if="tooltip" :text="tooltip"><i class="fas fa-info-circle"></i></k-tooltip>
    </label>
    <slot></slot>
  </div>
</template>

<style scoped>
.k-form-field .fa-info-circle {
  margin-left: 4px;
}
</style>

<script>
import KTooltip from '@base-components/k-tooltip.vue';

export default {
  name: 'KFormField',

  components: {
    KTooltip,
  },

  props: {
    label: {
      type: String,
      default: '',
    },
    fieldId: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: String,
      default: '',
    },
  },
};
</script>
